if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      };

      const languageButtons = this.querySelectorAll('[data-type="language"]');

      for (const button of languageButtons) {
        const parentButton = button.closest('[data-custom-option]') || button;

      parentButton.addEventListener('mouseover', () => {
        parentButton.setAttribute('data-active', true);
      });

        parentButton.addEventListener('mouseout', () => {
          parentButton.removeAttribute('data-active');
        });
      }

      languageButtons.forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );
    }

    onItemClick(event) {
      event.preventDefault();
      window.location.href = event.currentTarget.dataset.url;
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
